import { IApplicationState } from '../../types/redux';
import { IMlReview } from '../../types/objectInfo/mlReview';

export function getMasterReview(state: IApplicationState): IMlReview | null {
  return state.objectInfo.mlReview;
}
